import { useEffect, useState } from "react";
import Mode from "../../components/styles/Mode";
import { RaceBy } from "@uiball/loaders";
import { useDispatch, useSelector } from "react-redux";
import Flexbox from "../../components/Flexbox";
import Spacebox from "../../components/Spacebox";
import { Typography } from "@mui/material";
import constant from "../../utilities/Constants";
import Grid from "../../components/Grid";
import '../../css/turboform.css'
import { extractUTMParameters, isPlausibleHumanName, isValidEmail, isValidUSPhoneNumber } from "../../utilities/utils";
import requests from "../../handlers/requests";
import { useNavigate } from "react-router-dom";
import cookies from "../../utilities/Cookies";
import { updatedarkmode } from "../../features/mode";
import NoticeText from "../../components/NoticeText";


const TurboFormCL = () => {


    // recieves email, phone, first name, last name, contact_id, saved & error
    // if save = false:
    //    collect debt_amount & state and send to server to create new traffic collection and send to GHL
    // else:
    //    update user details in db
    // send to /turbo url params contact_id & source=ghl-survey

    const mode = useSelector(state => state.darkmode.value)
    const dispatch = useDispatch()

    const navigate = useNavigate()


    const [email, setEmail] = useState(null)
    const [phone, setPhone] = useState(null)
    const [firstName, setFirstName] = useState(null)
    const [lastName, setLastName] = useState(null)
    const [contactId, setContactId] = useState(null)
    const [trustedCertUrl, setTrustedCertUrl] = useState(null)

    const [amount, setAmount] = useState(15000)
    const [state, setState] = useState(constant.states[0])

    const [error, setError] = useState(null)
    const [saved, setSaved] = useState('false')

    const [loading, setLoading] = useState(true)
    const [isLoading, setIsLoading] = useState(false)

    const scrollToTop = () => window.scrollTo({ behavior: 'smooth', top: 0 })


    const main = () => {
        const urlParams = new URLSearchParams(window.location.search)
        const email_ = urlParams.get('email')
        const phone_ = urlParams.get('phone')
        const first_name = urlParams.get('firstname')
        const last_name = urlParams.get('lastname')
        const contact_id = urlParams.get('contact_id')
        const trusted_cert_url = urlParams.get('trusted_cert_url')
        const saved_ = urlParams.get('saved')
        const error_ = urlParams.get('error')

        setEmail(email_)
        setPhone(phone_)
        setFirstName(first_name)
        setLastName(last_name)
        setContactId(contact_id)
        setTrustedCertUrl(trusted_cert_url)
        setSaved(saved_)
        setError(error_)
        setLoading(false)
    }

    const saveOrUpdateUser = () => {
        if (isValidEmail(email)) {
            if (isValidUSPhoneNumber(phone)) {
                if (isPlausibleHumanName(firstName) && isPlausibleHumanName(lastName)) {
                    setIsLoading(true)
                    if (saved === 'true')
                        updateUser()
                    else
                        saveUser()
                } else {
                    setError('Invalid Name')
                    scrollToTop()
                }
            } else {
                setError('Invalid Phone number')
                scrollToTop()
            }
        } else {
            setError('Invalid Email address')
            scrollToTop()
        }
    }

    const saveToGhl = () => {
        // send details to ghl
        fetch('https://services.leadconnectorhq.com/hooks/1ujUGYClu0F6PlFv72Bf/webhook-trigger/e3a61ca5-4ff1-4ca5-a970-25cbcb3365a6', {
            method: 'POST',
            headers: { "Content-Type": "application/json", "Accept": "/application/json" },
            body: JSON.stringify({
                first_name: firstName, last_name: lastName, email, phone, income: '', state: state,
                debt_type: '',
                debt_amount: amount,
                credit_score: ''
            })
        }).then(res => {
            if (res.ok)
                return res.json()
            else
                throw Error(res.statusText)
        }).then(res => {
            sendToTurbo()
        }).catch(e => {
            console.log(e)
            sendToTurbo()
        })
    }

    const updateUser = () => {
        const body = {
            firstname: firstName,
            lastname: lastName,
            email, phone, trusted_cert_url: trustedCertUrl
        }
        requests.post(`/api/users/${contactId}/update`, body, () => { }, () => { }, setError, () => { },
            (res) => {
                let user = res.data
                setIsLoading(false)
                if (user?.debt_amount > 20000)
                    sendToTurboArray()
                else
                    sendToTurbo()
            },
            null,
            (res) => {
                setIsLoading(false)
                setError(res.msg)
            }
        )
    }

    const saveUser = () => {
        const body = {
            first_name: firstName,
            last_name: lastName,
            email, phone,
            debt_amount: amount,
            contact_id: contactId,
            state: state,
            trusted_cert_url: trustedCertUrl
        }
        requests.post(`/api/users/create`, body, () => { }, () => { }, setError, () => { },
            (_) => {
                setIsLoading(false)
                saveToGhl()
            },
            null,
            (res) => {
                setIsLoading(false)
                setError(res.msg)
            }
        )
    }

    const sendToTurbo = () => {
        navigate(`/turbo?contact_id=${contactId}&source=ghl-survey&page=cl${extractUTMParameters(['cluid', 'utm_source', 'utm_medium', 'utm_content', 'utm_campaign', 'utm_term', 'utm_id', 'ad_id', 'tw_source', 'tw_adid'])}`, { replace: true })
    }

    const sendToTurboArray = () => {
        navigate(`/turbo-array?contact_id=${contactId}&source=ghl-survey&page=cl${extractUTMParameters(['cluid', 'utm_source', 'utm_medium', 'utm_content', 'utm_campaign', 'utm_term', 'utm_id', 'ad_id', 'tw_source', 'tw_adid'])}`, { replace: true })
    }

    useEffect(() => {
        cookies.setCookies('mode', 'light', 10)
        dispatch(updatedarkmode({ dark: false }))

        main()
        // eslint-disable-next-line
    }, [])

    return (
        <Mode>
            <div className="turbo-form-page" style={{ padding: '0px 20px' }}>
                {loading && <Flexbox justifyContent="center" alignItems="center" style={{ height: '90dvh', width: '100%' }}>
                    <RaceBy size={40} speed={0.9} color={mode.dark ? "white" : "black"} />
                </Flexbox>}
                <Spacebox padding="10px" />
                {(!loading && saved) && (
                    <div className="margin-auto mid " style={{ boxShadow: '0px 0px 20px #00000030' }}>
                        <div className="survey-copy">
                            <div className="margin-auto" style={{ padding: '40px' }}>
                                <span style={{ fontWeight: '700', fontSize: 25, textAlign: 'left' }} className="text-primary heading bold hide-on-med-and-down">
                                    Your Path to <u>Debt Relief</u> Starts Here
                                </span>
                                <span style={{ fontWeight: '700', fontSize: 22, textAlign: 'left' }} className="text-primary heading bold hide-on-large-only">
                                    Your Path to <u>Debt Relief</u> Starts Here
                                </span>
                                <Spacebox padding="10px" />
                                <span style={{ fontSize: 14 }}>
                                    <i style={{ opacity: .6 }}>
                                        <b className="bold open-sans">Based on the information you provided, we have multiple debt relief options available for you.</b>
                                    </i>
                                </span>
                                <Spacebox padding="10px" />
                                <Grid grid={2} gap="10px">
                                    <small className="hide-on-med-and-down" style={{ opacity: .6 }}>
                                        • See your qualifying debts
                                        (Automatically accessed for you)
                                    </small>
                                    <small className="hide-on-large-only" style={{ opacity: .6, fontSize: 10 }}>
                                        • See your qualifying debts
                                        (Automatically accessed for you)
                                    </small>
                                    <small className="hide-on-med-and-down" style={{ opacity: .6 }}>
                                        • Review your options and estimated savings
                                        (See estimated monthly/total savings)
                                    </small>
                                    <small className="hide-on-large-only" style={{ opacity: .6, fontSize: 10 }}>
                                        • Review your options and estimated savings
                                        (See estimated monthly/total savings)
                                    </small>
                                </Grid>
                                <Spacebox padding="10px" />
                                {/* Error message */}
                                {error && <div>
                                    <div style={{ background: 'rgba(255, 0, 0, 0.05)', padding: '10px', textAlign: 'center' }}>
                                        <Flexbox alignItems="center">
                                            <img src="/svgs/alert-circle-red.svg" alt="warning" style={{ width: 15 }} />
                                            <Spacebox padding="5px" />
                                            <small>
                                                <b className="trade-red">{error}</b>
                                            </small>
                                        </Flexbox>
                                    </div>
                                    <Spacebox padding="10px" />
                                </div>}
                                {saved === 'false' && (
                                    <div>
                                        <div>
                                            <Typography style={{ textAlign: 'center', fontSize: '14px' }}>
                                                <b className="open-sans">Select your debt amount balance</b>
                                            </Typography>
                                            <Spacebox padding="5px" />
                                            <Typography className="bold text-primary" variant="h3" style={{ textAlign: 'center', fontSize: '60px' }}>
                                                ${(amount).toLocaleString()}
                                            </Typography>
                                            <Spacebox padding="10px" />
                                            <div className="slidecontainer">
                                                <input
                                                    type="range"
                                                    min="10000"
                                                    max="20000"
                                                    value={amount}
                                                    onChange={(e) => setAmount(e.target.valueAsNumber)}
                                                    className="slider"
                                                    step={500}
                                                    name="no-name"
                                                />
                                            </div>
                                        </div>
                                        <Spacebox padding="10px" />
                                        <div>
                                            <small style={{ fontSize: 14 }} className="open-sans"><b>State of Residence</b></small>
                                            <Spacebox padding="2px" />
                                            <select
                                                value={state}
                                                onChange={(e) => setState(e.target.value)}
                                                name="no-name"
                                            >
                                                {(constant.states).map((st, i) => (
                                                    <option key={i} value={st}>{st}</option>
                                                ))}
                                            </select>
                                        </div>
                                        <Spacebox padding="10px" />
                                    </div>
                                )}
                                <Grid grid={2} gap='10px'>
                                    <div>
                                        <small style={{ fontSize: 14 }} className="open-sans"><b>First Name</b></small>
                                        <Spacebox padding="2px" />
                                        <input
                                            type="text"
                                            placeholder={"First Name"}
                                            value={firstName}
                                            onChange={(e) => setFirstName(e.target.value)}
                                        />
                                    </div>
                                    <div>
                                        <small style={{ fontSize: 14 }} className="open-sans"><b>Last Name</b></small>
                                        <Spacebox padding="2px" />
                                        <input
                                            type="text"
                                            placeholder="Last Name"
                                            value={lastName}
                                            onChange={(e) => setLastName(e.target.value)}
                                        />
                                    </div>
                                </Grid>
                                <Spacebox padding="10px" />
                                <div>
                                    <small style={{ fontSize: 14 }} className="open-sans"><b>Email</b></small>
                                    <Spacebox padding="2px" />
                                    <input
                                        type="email"
                                        placeholder="Email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                </div>
                                <Spacebox padding="10px" />
                                <div>
                                    <small style={{ fontSize: 14 }} className="open-sans"><b>Phone</b></small>
                                    <Spacebox padding="2px" />
                                    <input
                                        type="tel"
                                        placeholder="Phone"
                                        value={phone}
                                        onChange={(e) => setPhone(e.target.value)}
                                    />
                                </div>
                                <Spacebox padding="10px" />
                                <Flexbox justifyContent="center">
                                    <small className="terms hide-on-med-and-down" style={{ opacity: .5 }}>
                                        <b>We value your privacy.</b> Final Debt Relief, upon submission of this request form, will locate a debt consolidation provider serving residents of your state and request a free personalized debt evaluation on your behalf. As part of your free evaluation, buy clicking submit, you consent to receive a call, email, or text from Final Debt Relief or our <u>partner/ affiliates<span>TurboDebt, Clear One Advantage, Beyond Finance LLC dba Accredited Debt Relief, JG Wentworth, National Debt Relief or Americor</span></u> who may utilize auto-dial technology to contact you, even if the number you provided is on a do not call registry. There is no obligation. Your consent is not a condition to purchase any product or service. Your free evaluation will not impact your credit. If you choose not to consent, you may call us on <a href="tel:(855) 799-5699">(855) 799-5699</a> or email us at <a href="mailto:support@finaldebtrelief.com.">support@finaldebtrelief.com.</a>
                                    </small>
                                    <small className="terms hide-on-large-only" style={{ opacity: .5, fontSize: 8, lineHeight: '13px' }}>
                                        <b>We value your privacy.</b> Final Debt Relief, upon submission of this request form, will locate a debt consolidation provider serving residents of your state and request a free personalized debt evaluation on your behalf. As part of your free evaluation, buy clicking submit, you consent to receive a call, email, or text from Final Debt Relief or our <u>partner/ affiliates<span>TurboDebt, Clear One Advantage, Beyond Finance LLC dba Accredited Debt Relief, JG Wentworth, National Debt Relief or Americor</span></u> who may utilize auto-dial technology to contact you, even if the number you provided is on a do not call registry. There is no obligation. Your consent is not a condition to purchase any product or service. Your free evaluation will not impact your credit. If you choose not to consent, you may call us on <a href="tel:(855) 799-5699">(855) 799-5699</a> or email us at <a href="mailto:support@finaldebtrelief.com.">support@finaldebtrelief.com.</a>
                                    </small>
                                </Flexbox>
                                <Spacebox padding="10px" />
                                <div className="progress_holder">
                                    <div className="progress_idle9">
                                        9/9
                                    </div>
                                </div>
                                <Spacebox padding="10px" />
                                <NoticeText />
                            </div>
                        </div>
                        <div style={{ background: '#00359e', height: 50, display: 'flex', justifyContent: 'flex-end' }}>
                            <div onClick={saveOrUpdateUser} style={{ background: 'rgb(255, 161, 0)', padding: '17px 24px', cursor: 'pointer' }}>
                                <span style={{ fontSize: 15 }} className="text-white">
                                    {!isLoading && "SUBMIT"}
                                    {isLoading && "PLEASE WAIT..."}
                                </span>
                            </div>
                        </div>
                    </div>
                )}
                <Spacebox padding="10px" />
            </div>
        </Mode >
    );
}

export default TurboFormCL;